import { PREFECTURE_BY_REGION } from '../../prefecture/consts/prefecturesByRegion';

export const PREFECTURE_NAME_TO_ID = Object.values(PREFECTURE_BY_REGION).flat();
